import * as React from 'react';
import { flow, forEach, get } from 'lodash';
import {Field, formValueSelector} from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import {IDriver} from '../../../../../../data/api/models';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import {isRequired} from '../../../../../../util/validators';

interface IDriverNonEquineTradesProps {
  extendedUsers: any[];
  drivers: IDriver[];
}

class DriverNonEquineTrades extends React.Component<IDriverNonEquineTradesProps> {
  public render() {
    const { extendedUsers, drivers } = this.props;

    // filter only the drivers that are included, so we map all Drivers and filter on extendedUsers
    const applicableDrivers = {};
    forEach(drivers, (driver, key) => {
      const driverFound = Object.values(extendedUsers).filter((extendedUser) => {
        return driver.id === extendedUser.driver;
      });
      if (driverFound.length > 0) {
        applicableDrivers[key] = driver;
      }
    });

    const driverNonEquineTrades = Object.keys(applicableDrivers).map((key) => {
      const driver: IDriver = applicableDrivers[key];
      return (
        <div key={key}>
          <Row>
            <Col componentClass={ControlLabel} sm={4}>
              {driver.title + ' ' + driver.firstName + ' ' + driver.lastName}
            </Col>
            <Col sm={8}>
              <FormGroup controlId={`driver.non_equine_trade.${key}`}>
                <Col sm={12} className="no-padding-left">
                  <Col sm={12}>
                    <Field
                      name={`drivers[${key}].nonEquineTrade`}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                    />
                  </Col>
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </div>
      );
    });

    return (
      <div>
        {driverNonEquineTrades}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const drivers = selector(state, 'drivers');

      return {
        quote: state.quote,
        drivers,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(DriverNonEquineTrades);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/components/DriverNonEquineTrades/index.tsx